// // components/layout/Layout.jsx
// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useLocation } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import Header from "./Header";
// import MobileNav from "./MobileNav";
// import { useTheme } from "../../hooks/useTheme";
// import { useAuth } from "../../providers/AuthProvider";
// import FloatingCartButton from "../FloatingCartButton";
// import {
//   X,
//   ChevronLeft,
//   ChevronRight,
//   AlertCircle,
//   Info,
//   Bell,
//   ExternalLink,
//   MessageCircle,
//   ArrowUpRight,
// } from "lucide-react";

// const Layout = ({ children }) => {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   const [notices, setNotices] = useState([]);
//   const [currentNoticeIndex, setCurrentNoticeIndex] = useState(0);
//   const [showNoticeBar, setShowNoticeBar] = useState(true);
//   const [showCriticalModal, setShowCriticalModal] = useState(false);
//   const [criticalNotice, setCriticalNotice] = useState(null);
//   const [whatsappDragging, setWhatsappDragging] = useState(false);
//   const [whatsappPos, setWhatsappPos] = useState(null); // {x, y} | null = default
//   const [isHoveringWhatsApp, setIsHoveringWhatsApp] = useState(false);

//   const location = useLocation();
//   const { colors } = useTheme();
//   const { authFetch, isAuthenticated } = useAuth();

//   const timerRef = useRef(null);
//   const whatsappRef = useRef(null);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const rafRef = useRef(null);

//   // ---- Notices ----
//   useEffect(() => {
//     if (!isAuthenticated) return;
//     let cancelled = false;
//     (async () => {
//       try {
//         const res = await authFetch("/accounts/notices/active/");
//         const data = await res.json();
//         if (cancelled) return;
//         if (res.ok && data.status === "success") {
//           const active = data.data || [];
//           setNotices(active);

//           const lastShown = localStorage.getItem("critical_modal_shown");
//           const hours = lastShown
//             ? (Date.now() - new Date(lastShown).getTime()) / 3.6e6
//             : Infinity;
//           const critical = active.find(
//             (n) => n.priority === "URGENT" || n.priority === "HIGH"
//           );
//           if (critical && hours >= 24) {
//             setCriticalNotice(critical);
//             setShowCriticalModal(true);
//             localStorage.setItem("critical_modal_shown", new Date().toISOString());
//           }

//           const dismissed = localStorage.getItem("dismissed_notices");
//           const ids = dismissed ? JSON.parse(dismissed) : [];
//           setShowNoticeBar(active.some((n) => !ids.includes(n.id)));
//         }
//       } catch (e) {
//         console.error("notices:", e);
//       }
//     })();
//     return () => {
//       cancelled = true;
//     };
//   }, [authFetch, isAuthenticated]);

//   useEffect(() => {
//     if (notices.length > 1 && showNoticeBar) {
//       timerRef.current = setInterval(() => {
//         setCurrentNoticeIndex((p) => (p + 1) % notices.length);
//       }, 6000);
//       return () => clearInterval(timerRef.current);
//     }
//   }, [notices.length, showNoticeBar]);

//   // ---- Responsive ----
//   useEffect(() => {
//     const onResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);
//       setSidebarOpen(!mobile);
//     };
//     onResize();
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   useEffect(() => {
//     if (isMobile) setSidebarOpen(false);
//   }, [location.pathname, isMobile]);

//   // ---- Notice helpers ----
//   const dismissedIds = () => {
//     try {
//       return JSON.parse(localStorage.getItem("dismissed_notices") || "[]");
//     } catch {
//       return [];
//     }
//   };

//   const dismissNotice = (id) => {
//     const ids = dismissedIds();
//     if (!ids.includes(id)) ids.push(id);
//     localStorage.setItem("dismissed_notices", JSON.stringify(ids));
//     if (notices.every((n) => ids.includes(n.id))) {
//       setShowNoticeBar(false);
//     } else {
//       const nextIdx = notices.findIndex(
//         (n, i) => !ids.includes(n.id) && i !== currentNoticeIndex
//       );
//       if (nextIdx >= 0) setCurrentNoticeIndex(nextIdx);
//     }
//   };

//   const dismissAll = () => {
//     localStorage.setItem(
//       "dismissed_notices",
//       JSON.stringify(notices.map((n) => n.id))
//     );
//     setShowNoticeBar(false);
//   };

//   const priorityColor = (p) =>
//   ({
//     URGENT: "#EF4444",
//     HIGH: "#F59E0B",
//     MEDIUM: "#3B82F6",
//     LOW: "#8B5CF6",
//   }[p] || "#6B7280");

//   const priorityBg = (p) => `${priorityColor(p)}1A`;

//   const priorityIcon = (p) =>
//     p === "URGENT" || p === "HIGH" ? (
//       <AlertCircle size={16} />
//     ) : p === "MEDIUM" ? (
//       <Info size={16} />
//     ) : (
//       <Bell size={16} />
//     );

//   const currentNotice = notices[currentNoticeIndex];
//   const undismissedCount = notices.filter(
//     (n) => !dismissedIds().includes(n.id)
//   ).length;

//   // ---- WhatsApp FAB drag ----
//   const onDragStart = (clientX, clientY) => {
//     const rect = whatsappRef.current?.getBoundingClientRect();
//     if (rect) {
//       dragOffset.current = { x: clientX - rect.left, y: clientY - rect.top };
//       setWhatsappPos({ x: rect.left, y: rect.top });
//     }
//     setWhatsappDragging(true);
//   };

//   const onDragMove = useCallback((clientX, clientY) => {
//     if (rafRef.current) return;
//     rafRef.current = requestAnimationFrame(() => {
//       rafRef.current = null;
//       const size = 64;
//       setWhatsappPos({
//         x: Math.max(8, Math.min(window.innerWidth - size - 8, clientX - dragOffset.current.x)),
//         y: Math.max(8, Math.min(window.innerHeight - size - 8, clientY - dragOffset.current.y)),
//       });
//     });
//   }, []);

//   useEffect(() => {
//     if (!whatsappDragging) return;
//     const mm = (e) => onDragMove(e.clientX, e.clientY);
//     const tm = (e) => onDragMove(e.touches[0].clientX, e.touches[0].clientY);
//     const up = () => setWhatsappDragging(false);
//     window.addEventListener("mousemove", mm);
//     window.addEventListener("mouseup", up);
//     window.addEventListener("touchmove", tm, { passive: true });
//     window.addEventListener("touchend", up);
//     return () => {
//       window.removeEventListener("mousemove", mm);
//       window.removeEventListener("mouseup", up);
//       window.removeEventListener("touchmove", tm);
//       window.removeEventListener("touchend", up);
//     };
//   }, [whatsappDragging, onDragMove]);

//   const whatsappChannelLink =
//     "https://chat.whatsapp.com/LTaaIBgg7Hb7TRuLOyZDw7";

//   const fabStyle = whatsappPos
//     ? { left: whatsappPos.x, top: whatsappPos.y, bottom: "auto" }
//     : { right: 20, bottom: isMobile ? 84 : 24 };

//   return (
//     <div
//       style={{
//         display: "flex",
//         height: "100dvh",
//         overflow: "hidden",
//         background: colors.mainBg,
//       }}
//     >
//       <Sidebar
//         isOpen={sidebarOpen}
//         isMobile={isMobile}
//         onClose={() => setSidebarOpen(false)}
//       />

//       <div
//         style={{
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//           minWidth: 0,
//           height: "100dvh",
//           overflow: "hidden",
//         }}
//       >
//         <Header
//           toggleSidebar={() => setSidebarOpen((v) => !v)}
//           isMobile={isMobile}
//           sidebarOpen={sidebarOpen}
//         />

//         <main
//           style={{
//             flex: 1,
//             overflowY: "auto",
//             overflowX: "hidden",
//             padding: isMobile ? "14px 12px 88px" : "20px 24px 28px",
//             background: colors.mainBg,
//             overscrollBehavior: "contain",
//             WebkitOverflowScrolling: "touch",
//             scrollbarWidth: "thin",
//             scrollbarColor: `${colors.border} transparent`,
//           }}
//         >
//           {/* Notice Bar */}
//           {showNoticeBar && currentNotice && undismissedCount > 0 && (
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 12,
//                 padding: "10px 12px",
//                 borderRadius: 12,
//                 background: colors.raisedBg,
//                 border: `1px solid ${priorityColor(currentNotice.priority)}55`,
//                 marginBottom: 14,
//                 boxShadow: `0 2px 10px ${priorityColor(currentNotice.priority)}12`,
//                 animation: "noticeIn 0.2s ease",
//               }}
//             >
//               <span
//                 style={{
//                   width: 30,
//                   height: 30,
//                   borderRadius: 15,
//                   background: priorityBg(currentNotice.priority),
//                   color: priorityColor(currentNotice.priority),
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   flexShrink: 0,
//                 }}
//               >
//                 {priorityIcon(currentNotice.priority)}
//               </span>
//               <div style={{ flex: 1, minWidth: 0 }}>
//                 <div
//                   style={{
//                     fontSize: 13,
//                     fontWeight: 700,
//                     color: colors.heading,
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                   }}
//                 >
//                   {currentNotice.title}
//                 </div>
//                 <div
//                   style={{
//                     fontSize: 12,
//                     color: colors.secondaryText,
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                   }}
//                 >
//                   {currentNotice.message}
//                 </div>
//               </div>
//               {currentNotice.link_url && currentNotice.link_text && (
//                 <a
//                   href={currentNotice.link_url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 4,
//                     fontSize: 12,
//                     fontWeight: 600,
//                     color: colors.btnBg,
//                     textDecoration: "none",
//                     padding: "4px 10px",
//                     borderRadius: 7,
//                     background: colors.activeBg,
//                     flexShrink: 0,
//                   }}
//                 >
//                   {currentNotice.link_text}
//                   <ExternalLink size={12} />
//                 </a>
//               )}
//               {undismissedCount > 1 && (
//                 <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
//                   <NavArrow
//                     onClick={() =>
//                       setCurrentNoticeIndex(
//                         (p) => (p - 1 + notices.length) % notices.length
//                       )
//                     }
//                     colors={colors}
//                   >
//                     <ChevronLeft size={15} />
//                   </NavArrow>
//                   <NavArrow
//                     onClick={() =>
//                       setCurrentNoticeIndex((p) => (p + 1) % notices.length)
//                     }
//                     colors={colors}
//                   >
//                     <ChevronRight size={15} />
//                   </NavArrow>
//                 </div>
//               )}
//               <NavArrow
//                 onClick={() => dismissNotice(currentNotice.id)}
//                 colors={colors}
//                 title="Dismiss"
//               >
//                 <X size={15} />
//               </NavArrow>
//             </div>
//           )}

//           {children}
//         </main>

//         {isMobile && <MobileNav />}
//         <FloatingCartButton />
//       </div>

//       {/* WhatsApp Channel FAB */}
//       <a
//         ref={whatsappRef}
//         href={whatsappChannelLink}
//         target="_blank"
//         rel="noopener noreferrer"
//         aria-label="Join our WhatsApp Channel"
//         style={{
//           position: "fixed",
//           ...fabStyle,
//           zIndex: 90,
//           width: 54,
//           height: 54,
//           borderRadius: "50%",
//           background: "#25D366",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "#FFFFFF",
//           textDecoration: "none",
//           cursor: whatsappDragging ? "grabbing" : "pointer",
//           touchAction: "none",
//           userSelect: "none",
//           WebkitUserSelect: "none",
//           boxShadow: isHoveringWhatsApp
//             ? "0 10px 28px rgba(37, 211, 102, 0.45)"
//             : "0 4px 14px rgba(37, 211, 102, 0.32)",
//           transform: whatsappDragging
//             ? "scale(1.02)"
//             : isHoveringWhatsApp
//               ? "scale(1.04)"
//               : "scale(1)",
//           transition: whatsappDragging
//             ? "none"
//             : "transform 0.18s ease, box-shadow 0.18s ease",
//         }}
//         onMouseDown={(e) => {
//           // Drag only if the user actually moves — otherwise let the link click.
//           const startX = e.clientX;
//           const startY = e.clientY;
//           let dragged = false;
//           const maybeDrag = (moveEvent) => {
//             if (
//               !dragged &&
//               (Math.abs(moveEvent.clientX - startX) > 4 ||
//                 Math.abs(moveEvent.clientY - startY) > 4)
//             ) {
//               dragged = true;
//               onDragStart(startX, startY);
//             }
//           };
//           const stop = () => {
//             window.removeEventListener("mousemove", maybeDrag);
//             window.removeEventListener("mouseup", stop);
//             if (dragged) {
//               // Prevent the anchor from following through on a drag.
//               window.addEventListener(
//                 "click",
//                 (ev) => ev.preventDefault(),
//                 { once: true, capture: true }
//               );
//             }
//           };
//           window.addEventListener("mousemove", maybeDrag);
//           window.addEventListener("mouseup", stop);
//         }}
//         onTouchStart={(e) => {
//           const touch = e.touches[0];
//           const startX = touch.clientX;
//           const startY = touch.clientY;
//           let dragged = false;
//           const maybeDrag = (moveEvent) => {
//             const t = moveEvent.touches[0];
//             if (
//               !dragged &&
//               (Math.abs(t.clientX - startX) > 6 ||
//                 Math.abs(t.clientY - startY) > 6)
//             ) {
//               dragged = true;
//               onDragStart(startX, startY);
//             }
//           };
//           const stop = () => {
//             window.removeEventListener("touchmove", maybeDrag);
//             window.removeEventListener("touchend", stop);
//           };
//           window.addEventListener("touchmove", maybeDrag, { passive: true });
//           window.addEventListener("touchend", stop);
//         }}
//         onMouseEnter={() => setIsHoveringWhatsApp(true)}
//         onMouseLeave={() => setIsHoveringWhatsApp(false)}
//       >
//         <svg
//           width="28"
//           height="28"
//           viewBox="0 0 24 24"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="1.9"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           aria-hidden
//         >
//           {/* WhatsApp-style bubble with phone glyph */}
//           <path d="M20.5 11.5a8.4 8.4 0 0 1-12.5 7.4L3.5 20l1.2-4.3A8.4 8.4 0 1 1 20.5 11.5Z" />
//           <path d="M8.7 9.1c.2-.5.5-.6.9-.6h.7c.2 0 .4.1.5.5l.6 1.4c.1.2 0 .4-.1.6l-.5.6c-.1.2-.2.4 0 .6.4.7 1.2 1.6 2.4 2 .2.1.4 0 .6-.1l.6-.6c.2-.2.4-.2.6-.1l1.4.6c.3.1.4.3.4.5v.7c0 .5-.4 1-1 1.1-.6.1-1.4.2-2.3-.1-1-.4-2.1-1.1-3-2-1-1-1.7-2.1-1.9-3.1-.2-.9 0-1.7.1-2Z" />
//         </svg>
//       </a>

//       {/* Critical modal */}
//       {showCriticalModal && criticalNotice && (
//         <div
//           onClick={(e) => {
//             if (e.target === e.currentTarget) setShowCriticalModal(false);
//           }}
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: colors.scrim,
//             backdropFilter: "blur(6px)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 2000,
//             padding: 16,
//             animation: "fadeIn 0.2s ease",
//           }}
//         >
//           <div
//             style={{
//               background: colors.raisedBg,
//               borderRadius: 18,
//               maxWidth: 460,
//               width: "100%",
//               padding: 24,
//               boxShadow: `0 24px 80px ${colors.shadowStrong}`,
//               position: "relative",
//               overflow: "hidden",
//               animation: "modalIn 0.22s ease",
//             }}
//           >
//             <div
//               style={{
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 height: 4,
//                 background: priorityColor(criticalNotice.priority),
//               }}
//             />
//             <div
//               style={{
//                 display: "flex",
//                 gap: 14,
//                 alignItems: "flex-start",
//                 marginBottom: 14,
//               }}
//             >
//               <span
//                 style={{
//                   width: 44,
//                   height: 44,
//                   borderRadius: 22,
//                   background: priorityBg(criticalNotice.priority),
//                   color: priorityColor(criticalNotice.priority),
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   flexShrink: 0,
//                 }}
//               >
//                 <AlertCircle size={24} />
//               </span>
//               <div style={{ flex: 1 }}>
//                 <div
//                   style={{
//                     fontSize: 18,
//                     fontWeight: 800,
//                     color: colors.heading,
//                     letterSpacing: -0.3,
//                     marginBottom: 4,
//                   }}
//                 >
//                   {criticalNotice.title}
//                 </div>
//                 <span
//                   style={{
//                     fontSize: 10,
//                     fontWeight: 700,
//                     padding: "2px 10px",
//                     borderRadius: 10,
//                     background: priorityBg(criticalNotice.priority),
//                     color: priorityColor(criticalNotice.priority),
//                     textTransform: "uppercase",
//                     letterSpacing: 0.4,
//                   }}
//                 >
//                   {criticalNotice.priority_label}
//                 </span>
//               </div>
//             </div>

//             <div
//               style={{
//                 fontSize: 14,
//                 color: colors.text,
//                 lineHeight: 1.6,
//                 padding: "12px 14px",
//                 background: colors.subtleBg,
//                 borderRadius: 10,
//                 marginBottom: 16,
//               }}
//             >
//               {criticalNotice.message}
//             </div>

//             {criticalNotice.link_url && criticalNotice.link_text && (
//               <a
//                 href={criticalNotice.link_url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 6,
//                   color: colors.btnBg,
//                   textDecoration: "none",
//                   fontWeight: 700,
//                   fontSize: 13.5,
//                   marginBottom: 16,
//                   padding: "8px 14px",
//                   borderRadius: 9,
//                   background: colors.activeBg,
//                 }}
//               >
//                 {criticalNotice.link_text}
//                 <ExternalLink size={15} />
//               </a>
//             )}

//             <button
//               onClick={() => setShowCriticalModal(false)}
//               style={{
//                 width: "100%",
//                 padding: 12,
//                 borderRadius: 10,
//                 border: "none",
//                 background: colors.btnBg,
//                 color: colors.btnText,
//                 cursor: "pointer",
//                 fontWeight: 700,
//                 fontSize: 14.5,
//               }}
//             >
//               Got it
//             </button>
//             <div
//               style={{
//                 marginTop: 10,
//                 fontSize: 11,
//                 color: colors.secondaryText,
//                 textAlign: "center",
//                 opacity: 0.7,
//               }}
//             >
//               This notice won't show again for 24 hours
//             </div>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
//         @keyframes noticeIn {
//           from { opacity: 0; transform: translateY(-6px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         @keyframes modalIn {
//           from { opacity: 0; transform: scale(0.96); }
//           to { opacity: 1; transform: scale(1); }
//         }
//       `}</style>
//     </div>
//   );
// };

// const NavArrow = ({ onClick, children, colors, title }) => (
//   <button
//     onClick={onClick}
//     title={title}
//     style={{
//       width: 28,
//       height: 28,
//       borderRadius: 8,
//       background: "transparent",
//       border: "none",
//       color: colors.secondaryText,
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//     }}
//     onMouseEnter={(e) => (e.currentTarget.style.background = colors.hoverBg)}
//     onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
//   >
//     {children}
//   </button>
// );

// export default Layout;



















// components/layout/Layout.jsx
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import MobileNav from "./MobileNav";
import { useTheme } from "../../hooks/useTheme";
import { useAuth } from "../../providers/AuthProvider";
import FloatingCartButton from "../FloatingCartButton";
import {
  X,
  ChevronLeft,
  ChevronRight,
  AlertCircle,
  Info,
  Bell,
  ExternalLink,
  MessageCircle,
  ArrowUpRight,
} from "lucide-react";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [notices, setNotices] = useState([]);
  const [currentNoticeIndex, setCurrentNoticeIndex] = useState(0);
  const [showNoticeBar, setShowNoticeBar] = useState(true);
  const [showCriticalModal, setShowCriticalModal] = useState(false);
  const [criticalNotice, setCriticalNotice] = useState(null);
  const [whatsappDragging, setWhatsappDragging] = useState(false);
  const [whatsappPos, setWhatsappPos] = useState(null);
  const [isHoveringWhatsApp, setIsHoveringWhatsApp] = useState(false);

  const location = useLocation();
  const { colors } = useTheme();
  const { authFetch, isAuthenticated } = useAuth();

  const timerRef = useRef(null);
  const whatsappRef = useRef(null);
  const dragOffset = useRef({ x: 0, y: 0 });
  const rafRef = useRef(null);

  // ---- Notices ----
  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await authFetch("/accounts/notices/active/");
        const data = await res.json();
        if (cancelled) return;
        if (res.ok && data.status === "success") {
          const active = data.data || [];
          setNotices(active);

          const lastShown = localStorage.getItem("critical_modal_shown");
          const hours = lastShown
            ? (Date.now() - new Date(lastShown).getTime()) / 3.6e6
            : Infinity;
          const critical = active.find(
            (n) => n.priority === "URGENT" || n.priority === "HIGH"
          );
          if (critical && hours >= 24) {
            setCriticalNotice(critical);
            setShowCriticalModal(true);
            localStorage.setItem("critical_modal_shown", new Date().toISOString());
          }

          const dismissed = localStorage.getItem("dismissed_notices");
          const ids = dismissed ? JSON.parse(dismissed) : [];
          setShowNoticeBar(active.some((n) => !ids.includes(n.id)));
        }
      } catch (e) {
        console.error("notices:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authFetch, isAuthenticated]);

  useEffect(() => {
    if (notices.length > 1 && showNoticeBar) {
      timerRef.current = setInterval(() => {
        setCurrentNoticeIndex((p) => (p + 1) % notices.length);
      }, 6000);
      return () => clearInterval(timerRef.current);
    }
  }, [notices.length, showNoticeBar]);

  // ---- Responsive ----
  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      setSidebarOpen(!mobile);
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (isMobile) setSidebarOpen(false);
  }, [location.pathname, isMobile]);

  // ---- Notice helpers ----
  const dismissedIds = () => {
    try {
      return JSON.parse(localStorage.getItem("dismissed_notices") || "[]");
    } catch {
      return [];
    }
  };

  const dismissNotice = (id) => {
    const ids = dismissedIds();
    if (!ids.includes(id)) ids.push(id);
    localStorage.setItem("dismissed_notices", JSON.stringify(ids));
    if (notices.every((n) => ids.includes(n.id))) {
      setShowNoticeBar(false);
    } else {
      const nextIdx = notices.findIndex(
        (n, i) => !ids.includes(n.id) && i !== currentNoticeIndex
      );
      if (nextIdx >= 0) setCurrentNoticeIndex(nextIdx);
    }
  };

  const dismissAll = () => {
    localStorage.setItem(
      "dismissed_notices",
      JSON.stringify(notices.map((n) => n.id))
    );
    setShowNoticeBar(false);
  };

  const priorityColor = (p) =>
    ({
      URGENT: "#EF4444",
      HIGH: "#F59E0B",
      MEDIUM: "#3B82F6",
      LOW: "#8B5CF6",
    }[p] || "#6B7280");

  const priorityBg = (p) => `${priorityColor(p)}1A`;

  const priorityIcon = (p) =>
    p === "URGENT" || p === "HIGH" ? (
      <AlertCircle size={16} />
    ) : p === "MEDIUM" ? (
      <Info size={16} />
    ) : (
      <Bell size={16} />
    );

  const currentNotice = notices[currentNoticeIndex];
  const undismissedCount = notices.filter(
    (n) => !dismissedIds().includes(n.id)
  ).length;

  // ---- WhatsApp FAB drag ----
  const onDragStart = (clientX, clientY) => {
    const rect = whatsappRef.current?.getBoundingClientRect();
    if (rect) {
      dragOffset.current = { x: clientX - rect.left, y: clientY - rect.top };
      setWhatsappPos({ x: rect.left, y: rect.top });
    }
    setWhatsappDragging(true);
  };

  const onDragMove = useCallback((clientX, clientY) => {
    if (rafRef.current) return;
    rafRef.current = requestAnimationFrame(() => {
      rafRef.current = null;
      const size = 64;
      setWhatsappPos({
        x: Math.max(8, Math.min(window.innerWidth - size - 8, clientX - dragOffset.current.x)),
        y: Math.max(8, Math.min(window.innerHeight - size - 8, clientY - dragOffset.current.y)),
      });
    });
  }, []);

  useEffect(() => {
    if (!whatsappDragging) return;
    const mm = (e) => onDragMove(e.clientX, e.clientY);
    const tm = (e) => onDragMove(e.touches[0].clientX, e.touches[0].clientY);
    const up = () => setWhatsappDragging(false);
    window.addEventListener("mousemove", mm);
    window.addEventListener("mouseup", up);
    window.addEventListener("touchmove", tm, { passive: true });
    window.addEventListener("touchend", up);
    return () => {
      window.removeEventListener("mousemove", mm);
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchmove", tm);
      window.removeEventListener("touchend", up);
    };
  }, [whatsappDragging, onDragMove]);

  const whatsappChannelLink =
    "https://chat.whatsapp.com/LTaaIBgg7Hb7TRuLOyZDw7";

  const fabStyle = whatsappPos
    ? { left: whatsappPos.x, top: whatsappPos.y, bottom: "auto" }
    : { right: 20, bottom: isMobile ? 84 : 24 };

  return (
    <div
      style={{
        // Locked shell — fills the viewport exactly without 100dvh.
        // position: fixed + inset: 0 works on desktop AND mobile and
        // does not recalc when the mobile URL bar collapses.
        position: "fixed",
        inset: 0,
        display: "flex",
        overflow: "hidden",
        background: colors.mainBg,
      }}
    >
      <Sidebar
        isOpen={sidebarOpen}
        isMobile={isMobile}
        onClose={() => setSidebarOpen(false)}
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <Header
          toggleSidebar={() => setSidebarOpen((v) => !v)}
          isMobile={isMobile}
          sidebarOpen={sidebarOpen}
        />

        <main
          style={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            padding: isMobile ? "14px 12px 88px" : "20px 24px 28px",
            background: colors.mainBg,
            // overscrollBehavior removed — it was blocking the mobile
            // URL bar from collapsing on iOS.
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",
            scrollbarColor: `${colors.border} transparent`,
          }}
        >
          {/* Notice Bar */}
          {showNoticeBar && currentNotice && undismissedCount > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 12px",
                borderRadius: 12,
                background: colors.raisedBg,
                border: `1px solid ${priorityColor(currentNotice.priority)}55`,
                marginBottom: 14,
                boxShadow: `0 2px 10px ${priorityColor(currentNotice.priority)}12`,
                animation: "noticeIn 0.2s ease",
              }}
            >
              <span
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 15,
                  background: priorityBg(currentNotice.priority),
                  color: priorityColor(currentNotice.priority),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {priorityIcon(currentNotice.priority)}
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: colors.heading,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {currentNotice.title}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: colors.secondaryText,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {currentNotice.message}
                </div>
              </div>
              {currentNotice.link_url && currentNotice.link_text && (
                <a
                  href={currentNotice.link_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 12,
                    fontWeight: 600,
                    color: colors.btnBg,
                    textDecoration: "none",
                    padding: "4px 10px",
                    borderRadius: 7,
                    background: colors.activeBg,
                    flexShrink: 0,
                  }}
                >
                  {currentNotice.link_text}
                  <ExternalLink size={12} />
                </a>
              )}
              {undismissedCount > 1 && (
                <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <NavArrow
                    onClick={() =>
                      setCurrentNoticeIndex(
                        (p) => (p - 1 + notices.length) % notices.length
                      )
                    }
                    colors={colors}
                  >
                    <ChevronLeft size={15} />
                  </NavArrow>
                  <NavArrow
                    onClick={() =>
                      setCurrentNoticeIndex((p) => (p + 1) % notices.length)
                    }
                    colors={colors}
                  >
                    <ChevronRight size={15} />
                  </NavArrow>
                </div>
              )}
              <NavArrow
                onClick={() => dismissNotice(currentNotice.id)}
                colors={colors}
                title="Dismiss"
              >
                <X size={15} />
              </NavArrow>
            </div>
          )}

          {children}
        </main>

        {isMobile && <MobileNav />}
        <FloatingCartButton />
      </div>

      {/* WhatsApp Channel FAB */}
      <a
        ref={whatsappRef}
        href={whatsappChannelLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Join our WhatsApp Channel"
        style={{
          position: "fixed",
          ...fabStyle,
          zIndex: 90,
          width: 54,
          height: 54,
          borderRadius: "50%",
          background: "#25D366",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#FFFFFF",
          textDecoration: "none",
          cursor: whatsappDragging ? "grabbing" : "pointer",
          touchAction: "none",
          userSelect: "none",
          WebkitUserSelect: "none",
          boxShadow: isHoveringWhatsApp
            ? "0 10px 28px rgba(37, 211, 102, 0.45)"
            : "0 4px 14px rgba(37, 211, 102, 0.32)",
          transform: whatsappDragging
            ? "scale(1.02)"
            : isHoveringWhatsApp
              ? "scale(1.04)"
              : "scale(1)",
          transition: whatsappDragging
            ? "none"
            : "transform 0.18s ease, box-shadow 0.18s ease",
        }}
        onMouseDown={(e) => {
          const startX = e.clientX;
          const startY = e.clientY;
          let dragged = false;
          const maybeDrag = (moveEvent) => {
            if (
              !dragged &&
              (Math.abs(moveEvent.clientX - startX) > 4 ||
                Math.abs(moveEvent.clientY - startY) > 4)
            ) {
              dragged = true;
              onDragStart(startX, startY);
            }
          };
          const stop = () => {
            window.removeEventListener("mousemove", maybeDrag);
            window.removeEventListener("mouseup", stop);
            if (dragged) {
              window.addEventListener(
                "click",
                (ev) => ev.preventDefault(),
                { once: true, capture: true }
              );
            }
          };
          window.addEventListener("mousemove", maybeDrag);
          window.addEventListener("mouseup", stop);
        }}
        onTouchStart={(e) => {
          const touch = e.touches[0];
          const startX = touch.clientX;
          const startY = touch.clientY;
          let dragged = false;
          const maybeDrag = (moveEvent) => {
            const t = moveEvent.touches[0];
            if (
              !dragged &&
              (Math.abs(t.clientX - startX) > 6 ||
                Math.abs(t.clientY - startY) > 6)
            ) {
              dragged = true;
              onDragStart(startX, startY);
            }
          };
          const stop = () => {
            window.removeEventListener("touchmove", maybeDrag);
            window.removeEventListener("touchend", stop);
          };
          window.addEventListener("touchmove", maybeDrag, { passive: true });
          window.addEventListener("touchend", stop);
        }}
        onMouseEnter={() => setIsHoveringWhatsApp(true)}
        onMouseLeave={() => setIsHoveringWhatsApp(false)}
      >
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M20.5 11.5a8.4 8.4 0 0 1-12.5 7.4L3.5 20l1.2-4.3A8.4 8.4 0 1 1 20.5 11.5Z" />
          <path d="M8.7 9.1c.2-.5.5-.6.9-.6h.7c.2 0 .4.1.5.5l.6 1.4c.1.2 0 .4-.1.6l-.5.6c-.1.2-.2.4 0 .6.4.7 1.2 1.6 2.4 2 .2.1.4 0 .6-.1l.6-.6c.2-.2.4-.2.6-.1l1.4.6c.3.1.4.3.4.5v.7c0 .5-.4 1-1 1.1-.6.1-1.4.2-2.3-.1-1-.4-2.1-1.1-3-2-1-1-1.7-2.1-1.9-3.1-.2-.9 0-1.7.1-2Z" />
        </svg>
      </a>

      {/* Critical modal */}
      {showCriticalModal && criticalNotice && (
        <div
          onClick={(e) => {
            if (e.target === e.currentTarget) setShowCriticalModal(false);
          }}
          style={{
            position: "fixed",
            inset: 0,
            background: colors.scrim,
            backdropFilter: "blur(6px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: 16,
            animation: "fadeIn 0.2s ease",
          }}
        >
          <div
            style={{
              background: colors.raisedBg,
              borderRadius: 18,
              maxWidth: 460,
              width: "100%",
              padding: 24,
              boxShadow: `0 24px 80px ${colors.shadowStrong}`,
              position: "relative",
              overflow: "hidden",
              animation: "modalIn 0.22s ease",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: 4,
                background: priorityColor(criticalNotice.priority),
              }}
            />
            <div
              style={{
                display: "flex",
                gap: 14,
                alignItems: "flex-start",
                marginBottom: 14,
              }}
            >
              <span
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 22,
                  background: priorityBg(criticalNotice.priority),
                  color: priorityColor(criticalNotice.priority),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <AlertCircle size={24} />
              </span>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 800,
                    color: colors.heading,
                    letterSpacing: -0.3,
                    marginBottom: 4,
                  }}
                >
                  {criticalNotice.title}
                </div>
                <span
                  style={{
                    fontSize: 10,
                    fontWeight: 700,
                    padding: "2px 10px",
                    borderRadius: 10,
                    background: priorityBg(criticalNotice.priority),
                    color: priorityColor(criticalNotice.priority),
                    textTransform: "uppercase",
                    letterSpacing: 0.4,
                  }}
                >
                  {criticalNotice.priority_label}
                </span>
              </div>
            </div>

            <div
              style={{
                fontSize: 14,
                color: colors.text,
                lineHeight: 1.6,
                padding: "12px 14px",
                background: colors.subtleBg,
                borderRadius: 10,
                marginBottom: 16,
              }}
            >
              {criticalNotice.message}
            </div>

            {criticalNotice.link_url && criticalNotice.link_text && (
              <a
                href={criticalNotice.link_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  color: colors.btnBg,
                  textDecoration: "none",
                  fontWeight: 700,
                  fontSize: 13.5,
                  marginBottom: 16,
                  padding: "8px 14px",
                  borderRadius: 9,
                  background: colors.activeBg,
                }}
              >
                {criticalNotice.link_text}
                <ExternalLink size={15} />
              </a>
            )}

            <button
              onClick={() => setShowCriticalModal(false)}
              style={{
                width: "100%",
                padding: 12,
                borderRadius: 10,
                border: "none",
                background: colors.btnBg,
                color: colors.btnText,
                cursor: "pointer",
                fontWeight: 700,
                fontSize: 14.5,
              }}
            >
              Got it
            </button>
            <div
              style={{
                marginTop: 10,
                fontSize: 11,
                color: colors.secondaryText,
                textAlign: "center",
                opacity: 0.7,
              }}
            >
              This notice won't show again for 24 hours
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes noticeIn {
          from { opacity: 0; transform: translateY(-6px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes modalIn {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

const NavArrow = ({ onClick, children, colors, title }) => (
  <button
    onClick={onClick}
    title={title}
    style={{
      width: 28,
      height: 28,
      borderRadius: 8,
      background: "transparent",
      border: "none",
      color: colors.secondaryText,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.background = colors.hoverBg)}
    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
  >
    {children}
  </button>
);

export default Layout;